<div class="observation-verification-container">
  <!-- Freightfox Header with Logo -->
  <div class="freightfox-header">
    <div class="logo-container">
      <img src="assets/images/ff_logo.svg" alt="Freightfox Logo" class="ff-logo">
    </div>
    <div class="header-divider"></div>
  </div>

  <!-- Loading State -->




    <!-- Success State with Details -->
  <div *ngIf="verificationDetails && !loading" class="success-container">
    
    <div class="details-card">
      <h4>Observation Details</h4>
      
      <!-- Compact Summary Grid -->
      <div class="compact-summary">
        <div class="summary-row">
         
          <div class="summary-item">
            <span class="summary-label">Indent ID</span>
            <span class="summary-value">{{ verificationDetails.indentDestinationId }}</span>
          </div>
        
        </div>
        <div class="summary-row">
          <div class="summary-item">
            <span class="summary-label">Reported Time</span>
            <span class="summary-value">{{ formatDate(verificationDetails.destReportedTime) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Unloading Time</span>
            <span class="summary-value">{{ formatDate(verificationDetails.unloadingTime) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Other Charges</span>
            <span class="summary-value">₹{{ verificationDetails.repackagingCharges?.toLocaleString() || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <!-- Material Details -->
      <div *ngIf="verificationDetails.materialDetails?.length > 0" class="material-details">
        <h5>Material Details</h5>
        <div class="material-card">
          <div *ngFor="let material of verificationDetails.materialDetails; let i = index" class="material-item">
            <div class="material-header">
              <span class="material-name">{{ material.material }}</span>
              <!-- <span class="material-sku">SKU: {{ material.sku }}</span> -->
            </div>
            <div class="material-stats">
              <div class="stat-item">
                <span class="stat-label">Quantity:</span>
                <span class="stat-value">{{ material.quantity?.toLocaleString() }} {{ material.shippingUnit }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Breakage:</span>
                <span class="stat-value">{{ material.breakageQuantity?.toLocaleString() || '0' }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Leakage:</span>
                <span class="stat-value">{{ material.leakageQuantity?.toLocaleString() || '0' }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Shortage:</span>
                <span class="stat-value">{{ material.shortageQuantity?.toLocaleString() || '0' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Documents -->
      <div *ngIf="verificationDetails.observationDocuments?.length > 0" class="documents-section">
        <h5>Documents ({{ verificationDetails.observationDocuments.length }})</h5>
        <div class="documents-grid">
          <div *ngFor="let doc of verificationDetails.observationDocuments" class="document-card">
            <div class="document-preview">
              <!-- Image Preview -->
              <img *ngIf="isImageFile(doc.documentName)" 
                   [src]="doc.documentUrl" 
                   [alt]="doc.documentName"
                   class="document-image"
                   (click)="openDocumentPreview(doc)">
              
              <!-- Video Preview -->
              <video *ngIf="isVideoFile(doc.documentName)" 
                     class="document-video"
                     controls
                     preload="metadata">
                <source [src]="doc.documentUrl" type="video/mp4">
                Your browser does not support the video tag.
              </video>
              
              <!-- File Icon for other types -->
              <div *ngIf="!isImageFile(doc.documentName) && !isVideoFile(doc.documentName)" 
                   class="document-file-icon">
                <span class="file-icon">📄</span>
                <span class="file-type">{{ getFileExtension(doc.documentName) }}</span>
              </div>
            </div>
            <div class="document-info">
              <span class="doc-name">{{ doc.documentName }}</span>
              <span class="doc-date">{{ formatDate(doc.createdOn) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Remarks -->
      <div *ngIf="verificationDetails.remarks" class="remarks-section">
        <h5>Remarks</h5>
        <p class="remarks-text">{{ verificationDetails.remarks }}</p>
      </div>
    </div>
  </div>

  <!-- No Access Code State -->
  <div *ngIf="!accessCode && !loading" class="no-access-container">
    <div class="warning-icon">⚠️</div>
    <h3>No Access Code Provided</h3>
    <p>Please provide a valid access code to verify the observation.</p>
  </div>

  
</div>
